import { render, staticRenderFns } from "./CreatedRole.vue?vue&type=template&id=7b3c0949&scoped=true"
import script from "./CreatedRole.vue?vue&type=script&lang=js"
export * from "./CreatedRole.vue?vue&type=script&lang=js"
import style0 from "./CreatedRole.vue?vue&type=style&index=0&id=7b3c0949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3c0949",
  null
  
)

export default component.exports